class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateUrl = this.dataset.updateUrl === 'true';
    this.setupInitialState();
  }

  setupInitialState() {
    // Initial setup of variant visibility
    this.updateSizeOptionsVisibility();
  }

  onVariantChange() {
    //console.log('Variant change triggered');
    this.updateOptions();
    this.updateSizeOptionsVisibility();
    this.updateVariantId();
    
    if (!this.currentVariant) {
      //console.log('No variant found');
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      //console.log('Current variant:', this.currentVariant);
      this.updateURL();
      this.updateVariantInput();
      this.updateSelectedVariantId();
      this.refreshSubscriptionWidget();
      this.toggleAddButton(!this.currentVariant.available, '', !this.currentVariant.available);
    }
  }

  updateSelectedVariantId() {
    if (!this.currentVariant) return;
    // Update the data-selected-id attribute on the variant-selects element
    this.setAttribute('data-selected-id', this.currentVariant.id);
  }

  updateSizeOptionsVisibility() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const unitFieldset = fieldsets.find(fieldset => fieldset.querySelector('legend').textContent.trim() === 'Unit');
    const sizeFieldset = fieldsets.find(fieldset => fieldset.querySelector('legend').textContent.trim() === 'Size');
    const gridTypeFieldset = fieldsets.find(fieldset => fieldset.querySelector('legend').textContent.trim() === 'Grind Type');
    
    if (!unitFieldset || !sizeFieldset) return;

    const selectedUnit = Array.from(unitFieldset.querySelectorAll('input')).find(radio => radio.checked)?.value;
    const sizeInputs = sizeFieldset.querySelectorAll('input');

    const grindTypeInputs = gridTypeFieldset.querySelectorAll('input');

    grindTypeInputs.forEach(input => {
      const label = gridTypeFieldset.querySelector(`label[for=${CSS.escape(input.id)}]`);
      const value = input.value;

      //console.log('Grind Type Label:', label);
      //console.log('Grind Type Value:', value);

      if (selectedUnit === 'K-cup') {
        const isWholeOption = value.includes('Whole');
        if (isWholeOption) {
          input.style.display = 'none';
          if (label) label.style.display = 'none';
        } else {
          input.style.removeProperty('display');
          if (label) label.style.removeProperty('display');
        }
        if (isWholeOption && input.checked) {
          //console.log('isWholeOption:', isWholeOption);
          const firstWholeOption = Array.from(grindTypeInputs).find(input => input.value.includes('Ground'));
          if (firstWholeOption) {
            firstWholeOption.checked = true;
            firstWholeOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } else {
        input.style.removeProperty('display');
        if (label) label.style.removeProperty('display');
      }
    });

    
    sizeInputs.forEach(input => {
      // Find the corresponding label using CSS.escape to properly escape the ID
      const label = sizeFieldset.querySelector(`label[for=${CSS.escape(input.id)}]`);
      const value = input.value;
      
      if (selectedUnit === 'K-cup') {
        // Show only Pack options for K-cups
        const isPackOption = value.includes('Pack');
        if (isPackOption) {
          input.style.removeProperty('display');
          if (label) label.style.removeProperty('display');
        } else {
          input.style.display = 'none';
          if (label) label.style.display = 'none';
        }
        
        // Select first pack option if current selection is a bag option
        if (!isPackOption && input.checked) {
          const firstPackOption = Array.from(sizeInputs).find(input => input.value.includes('Pack'));
          if (firstPackOption) {
            firstPackOption.checked = true;
            firstPackOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

      } else {
        // Show only Bag options for 2 Lb and 12 Oz
        const isBagOption = value.includes('Bag');
        if (isBagOption) {
          input.style.removeProperty('display');
          if (label) label.style.removeProperty('display');
        } else {
          input.style.display = 'none';
          if (label) label.style.display = 'none';
        }
        
        // Select first bag option if current selection is a pack option
        if (!isBagOption && input.checked) {
          const firstBagOption = Array.from(sizeInputs).find(input => input.value.includes('Bag'));
          if (firstBagOption) {
            firstBagOption.checked = true;
            firstBagOption.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    //console.log('Updated options:', this.options);
  }

  updateVariantId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.some((option, index) => {
        return this.options[index] !== option;
      });
    });
  }

  updateURL() {
    if (!this.currentVariant || !this.updateUrl) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  refreshSubscriptionWidget() {
    //console.log('Attempting to refresh subscription widget');
    const subscriptionWidget = document.getElementById('nw-subscription-widget');
    
    if (!subscriptionWidget) {
      console.log('No subscription widget found in DOM');
      return;
    }
    
    // Store the current selection before refresh
    const currentPlanSelection = document.querySelector('input[name="nw-plan-picker"]:checked')?.value || 'one-time';
    
    //console.log('Found subscription widget:', subscriptionWidget);
    //console.log('Current variant ID:', this.currentVariant.id);
    //console.log('Section ID:', this.dataset.section);

    // First try to get the section containing the subscription widget
    const sectionContainer = subscriptionWidget.closest('.shopify-section');
    const sectionId = sectionContainer ? sectionContainer.id.replace('shopify-section-', '') : this.dataset.section;

    const url = `${window.location.pathname}?variant=${this.currentVariant.id}&section_id=${sectionId}`;
    //console.log('Fetching from URL:', url);

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSubscriptionWidget = doc.getElementById('nw-subscription-widget');
        
        if (newSubscriptionWidget) {
          subscriptionWidget.innerHTML = newSubscriptionWidget.innerHTML;
          
          // Restore the previous selection
          const planInput = subscriptionWidget.querySelector(`input[name="nw-plan-picker"][value="${currentPlanSelection}"]`);
          if (planInput) {
            planInput.checked = true;
            // Trigger change event to ensure any dependent UI updates occur
            planInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      })
      .catch(error => {
        console.error('Error refreshing subscription widget:', error);
      });
  }

  reinitializeWidgetScripts(widget) {
    // Re-run any scripts that need to be initialized
    const scripts = widget.querySelectorAll('script');
    scripts.forEach(oldScript => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  toggleAddButton(disable = true, text = '', modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = addButton.dataset.defaultText || 'Add to cart';
    }

    if (!modifyClass) return;
    
    if (disable) {
      addButton.classList.add('disabled');
    } else {
      addButton.classList.remove('disabled');
    }
  }

  setUnavailable() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    if (!addButton) return;

    addButton.textContent = 'Unavailable';
    if (this.currentVariant) {
      document.getElementById(`price-${this.dataset.section}`)?.classList.add('hidden');
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);
